export default () => ({
    content: '',
    isLoading: false,
    fetchContent(activeSpectacleSlug) {

        if (!activeSpectacleSlug) {
            console.error('Не задан ярлык репертуара для блока Медиа.')
            return;
        }

        this.isLoading = true;

        const currentUrl = new URL(window.location.href);

        currentUrl.searchParams.set('media_repertoire_slug', activeSpectacleSlug);

        fetch(currentUrl.toString())
            .then(response => response.text())
            .then(html => {

                this.content = html;

                // Ждем отображение блока Медиа через template
                Alpine.nextTick().then(() => {

                    const media_block_content = document.querySelector('#media_block_content');

                    if (!media_block_content) {
                        console.log('Блок Медиа отсутствует на данной странице.')
                        return;
                    }

                    // Ждем анимацию прозрачности для скрытия старого HTML
                    setTimeout(() => {
                        media_block_content.innerHTML = html;
                        this.isLoading                = false;
                    }, 300)

                    console.log('Содержимое для блока Медиа установлено.')
                });

            })
            .catch(error => {
                this.isLoading = false;
                console.error('Ошибка при загрузке блока Медиа:', error);
            });
    },
    init() {

        // noinspection JSUnresolvedReference
        let activeSpectacleSlug = this.activeSpectacleSlug;

        this.fetchContent(activeSpectacleSlug);

        // noinspection JSUnresolvedReference
        this.$watch('activeSpectacleSlug', (activeSpectacleSlug) => {
            this.fetchContent(activeSpectacleSlug);
        });
    }
})
